import { createSelector } from 'reselect';

import { initialState } from './reducer';
import { PROFILE_TRANSFER_FORM_CONTENT_DICTIONARY } from './constants';

/**
 * Direct selector to the Gold Redirect state domain
 */
const selectGoldRedirectDomain = (state) => state.goldRedirect || initialState;

const selectGoldMigrationPLCookiesBoolean = (prop) => createSelector(
  makeSelectGoldRedirect('cookies'),
  (cookies) => !!cookies[prop],
);

const selectGoldMigrationPLCookiesProp = (prop) => createSelector(
  makeSelectGoldRedirect('cookies'),
  (cookies) => cookies[prop],
);

const selectGoldMigrationPLValidGoldRedirect = () => createSelector(
  makeSelectGoldRedirect('cookies'),
  ({
    goldMigrationPLGeneralLogin,
    goldMigrationPLPreLogin,
    goldMigrationPLProfileTransfer,
  }) =>
    !!goldMigrationPLGeneralLogin
    || !!goldMigrationPLPreLogin
    || !!goldMigrationPLProfileTransfer,
);

const selectGoldRedirectFormErrorsProp = (prop) => createSelector(
  makeSelectGoldRedirect('formErrors'),
  (formErrors) => formErrors[prop],
);

const selectGoldRedirectFormValuesProp = (prop) => createSelector(
  makeSelectGoldRedirect('formValues'),
  (formValues) => formValues[prop],
);

const selectGoldRedirectStatusProp = (prop) => createSelector(
  makeSelectGoldRedirect('status'),
  (status) => status[prop],
);

const selectProfileTransferFormProps = () => createSelector(
  makeSelectGoldRedirect('session'),
  makeSelectGoldRedirect('formValues'),
  (sessionData, formValues) => {
    const {
      email,
      isPasswordRequired,
      isUsernameRequired,
      operation,
      username,
      usernameForLogin,
    } = sessionData;
    const {
      confirmPassword,
      password,
      username: usernameVal,
    } = formValues.profileTransfer;
    const {
      accountTransferredLinkLabel,
      noRequiredField,
      onlyPasswordRequired,
      passwordAndUsernameRequired,
      submitButtonLabel,
    } = PROFILE_TRANSFER_FORM_CONTENT_DICTIONARY;
    let formHeader = '';
    let formText = '';
    let isSubmitButtonDisabled = true;

    if (!isUsernameRequired && isPasswordRequired) {
      formHeader = onlyPasswordRequired.header;
      formText = onlyPasswordRequired.text;
      isSubmitButtonDisabled = !password.length || !confirmPassword.length;
    }
    if (isUsernameRequired && isPasswordRequired) {
      formHeader = passwordAndUsernameRequired.header;
      formText = passwordAndUsernameRequired.text;
      isSubmitButtonDisabled = !usernameVal.length || !password.length || !confirmPassword.length;
    }
    if (!isUsernameRequired && !isPasswordRequired) {
      formHeader = noRequiredField.header;
      formText = noRequiredField.text;
    }
    const isAccountTransferComplete = !isUsernameRequired && !isPasswordRequired;

    return {
      accountTransferredLinkLabel,
      email,
      formHeader,
      formText,
      isAccountTransferComplete,
      isPasswordRequired,
      isSubmitButtonDisabled,
      isUsernameRequired,
      operation,
      submitButtonLabel,
      username,
      usernameForLogin,
    };
  },
);

const selectSessionProp = (prop) => createSelector(
  makeSelectGoldRedirect('session'),
  (session) => session[prop],
);

/**
 * Default selector used by Gold Redirect
 */
const makeSelectGoldRedirect = (prop) => createSelector(
  selectGoldRedirectDomain,
  (state) => state[prop],
);

export default makeSelectGoldRedirect;
export {
  selectGoldMigrationPLCookiesBoolean,
  selectGoldMigrationPLCookiesProp,
  selectGoldMigrationPLValidGoldRedirect,
  selectGoldRedirectFormErrorsProp,
  selectGoldRedirectFormValuesProp,
  selectGoldRedirectStatusProp,
  selectProfileTransferFormProps,
  selectSessionProp,
};
